'use client'

import type { Data } from '@repo/strapi'
import { BasicImage } from '@/components/page-builder/components/BasicImage'
import { NAVBAR_TEST_IDS } from '@/lib/test-ids'
import AppLink from '../AppLink'

interface LogoProps {
	logo?: Data.Component<'utilities.basic-image'> | null
}

export function Logo({ logo }: LogoProps) {
	if (!logo) return null

	return (
		<AppLink
			variant="none"
			href="/"
			className="h-6 w-27.5 lg:h-9 lg:w-33.5 rounded-none"
			data-test-id={NAVBAR_TEST_IDS.LOGO}
			tabIndex={0}
		>
			<BasicImage component={logo} className="object-contain" fill />
		</AppLink>
	)
}
